import { render, staticRenderFns } from "./CreateRoleDialog.vue?vue&type=template&id=41fc8c2c&"
import script from "./CreateRoleDialog.vue?vue&type=script&lang=js&"
export * from "./CreateRoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports